module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ready) ? _c('div', {
    key: _vm.handler,
    staticClass: "container container-upgradeAcct acct2",
    class: {
      'is-dark': _vm.showMode
    },
    attrs: {
      "id": "upgradeAcct"
    }
  }, [(_vm.planUpdatePending) ? _c('div', {
    staticClass: "plan-update-overlay"
  }, [_c('div', {
    staticClass: "plan-update-card"
  }, [_c('div', {
    staticClass: "plan-update-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "plan-update-title"
  }, [_vm._v("Updating your subscription…")]), _vm._v(" "), (!_vm.planUpdateSlow) ? _c('p', {
    staticClass: "plan-update-subtitle"
  }, [_vm._v("\n                Hang tight — we're confirming your payment with Stripe. This usually takes just a few seconds.\n            ")]) : _c('p', {
    staticClass: "plan-update-subtitle"
  }, [_vm._v("\n                Still finishing up on Stripe's side — this can occasionally take a little longer. We'll update this automatically as soon as it's done.\n            ")]), _vm._v(" "), (_vm.planUpdateSlow) ? _c('button', {
    staticClass: "plan-update-dismiss",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearPendingPlanUpdate
    }
  }, [_vm._v("\n                Continue to my account\n            ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('header', {
    staticClass: "acct-topbar"
  }, [_c('div', {
    staticClass: "tb-left"
  }, [_c('button', {
    staticClass: "tb-icon",
    attrs: {
      "aria-label": "Menu"
    },
    on: {
      "click": _vm.openNav
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4 7h16M4 12h16M4 17h16"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "theme-toggle",
    attrs: {
      "aria-label": _vm.showMode ? 'Switch to light mode' : 'Switch to dark mode'
    },
    on: {
      "click": _vm.toggleShowMode
    }
  }, [_c('span', {
    staticClass: "ti"
  }, [_vm._v(_vm._s(_vm.showMode ? '☀' : '☾'))]), _c('span', [_vm._v(_vm._s(_vm.showMode ? 'Light' : 'Dark'))])])]), _vm._v(" "), _c('div', {
    staticClass: "tb-right"
  }, [_c('a', {
    staticClass: "brand-logo-link",
    attrs: {
      "href": "#",
      "title": "Back to dashboard"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goDashboard.apply(null, arguments)
      }
    }
  }, [_c('img', {
    staticClass: "brand-logo",
    attrs: {
      "src": require('../assets/img/cuelist-full.svg'),
      "alt": "Cuelist"
    }
  })])])]), _vm._v(" "), _c('core-nav-main', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "acct-tabs",
    attrs: {
      "aria-label": "Account sections"
    }
  }, [_c('button', {
    staticClass: "acct-tab",
    class: {
      'is-active': _vm.activeTab === 'profile'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'profile'
      }
    }
  }, [_vm._v("My Profile")]), _vm._v(" "), _c('button', {
    staticClass: "acct-tab",
    class: {
      'is-active': _vm.activeTab === 'sessions'
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'sessions'
      }
    }
  }, [_vm._v("User Sessions")])]), _vm._v(" "), _c('main', {
    staticClass: "acct-content"
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'profile'),
      expression: "activeTab === 'profile'"
    }],
    staticClass: "acct-panel"
  }, [_c('div', {
    staticClass: "acct-grid"
  }, [_c('aside', {
    staticClass: "rail card"
  }, [_c('div', {
    staticClass: "avatar-wrap"
  }, [_c('div', {
    staticClass: "avatar"
  }, [(_vm.avatarUrl) ? _c('img', {
    attrs: {
      "src": _vm.avatarUrl,
      "alt": "Profile photo"
    }
  }) : _c('img', {
    attrs: {
      "src": require('../assets/img/silhouette.jpg'),
      "alt": "Profile photo"
    }
  })]), _vm._v(" "), (_vm.isEmailUser) ? _c('button', {
    staticClass: "avatar-edit",
    attrs: {
      "title": "Upload a new photo"
    },
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v("✎")]) : _vm._e()]), _vm._v(" "), _c('profile-photo', {
    ref: "imageUpload"
  }), _vm._v(" "), (_vm.editingName) ? _c('form', {
    staticClass: "rail-edit",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveName.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_username),
      expression: "new_username"
    }],
    staticClass: "rail-input",
    attrs: {
      "placeholder": "Name",
      "aria-label": "Name"
    },
    domProps: {
      "value": (_vm.new_username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rail-edit-actions"
  }, [_c('button', {
    staticClass: "btn btn-ghost",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEditingName
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])]) : _c('h1', {
    staticClass: "rail-name",
    class: {
      editable: _vm.isEmailUser
    },
    on: {
      "click": _vm.editName
    }
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), (_vm.editingEmail) ? _c('form', {
    staticClass: "rail-edit",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveEmail.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_email),
      expression: "new_email"
    }],
    staticClass: "rail-input",
    attrs: {
      "placeholder": "Email",
      "aria-label": "Email"
    },
    domProps: {
      "value": (_vm.new_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.new_email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rail-edit-actions"
  }, [_c('button', {
    staticClass: "btn btn-ghost",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEditingEmail
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])]) : _c('p', {
    staticClass: "rail-email",
    class: {
      editable: _vm.isEmailUser
    },
    on: {
      "click": _vm.editEmail
    }
  }, [_vm._v(_vm._s(_vm.user.email))]), _vm._v(" "), (_vm.isEmailUser) ? _c('p', {
    staticClass: "rail-sync"
  }, [_vm._v("Click your name, email, or photo to edit")]) : [_c('p', {
    staticClass: "rail-sync"
  }, [_vm._v("Synced from your Google account")]), _vm._v(" "), _c('a', {
    staticClass: "rail-manage",
    attrs: {
      "href": "https://myaccount.google.com/personal-info",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Manage in Google ↗")])], _vm._v(" "), _c('div', {
    staticClass: "status-pill"
  }, [_c('span', {
    staticClass: "dot"
  }), _vm._v(" " + _vm._s(_vm.isPaidCustomer ? 'Collaborator' : 'Observer'))]), _vm._v(" "), (_vm.isInstitutionAdmin) ? _c('div', {
    staticClass: "rail-block"
  }, [_c('div', {
    staticClass: "rail-div"
  }), _vm._v(" "), _c('p', {
    staticClass: "rail-block-label"
  }, [_vm._v("Institution")]), _vm._v(" "), _c('p', {
    staticClass: "rail-block-value"
  }, [_vm._v(_vm._s(_vm.user.institution_name))]), _vm._v(" "), _c('p', {
    staticClass: "rail-role"
  }, [_vm._v(_vm._s(_vm.user.subscription_level === 'educational' ? 'Educational Subscription Administrator' : 'Institutional Subscription Administrator'))])]) : _vm._e(), _vm._v(" "), (_vm.isEmailUser) ? _c('div', {
    staticClass: "rail-block"
  }, [_c('div', {
    staticClass: "rail-div"
  }), _vm._v(" "), _c('button', {
    staticClass: "rail-security",
    on: {
      "click": _vm.openPasswordModal
    }
  }, [_c('span', {
    staticClass: "lock"
  }, [_vm._v("🔒")]), _vm._v(" Change password")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('section', {
    staticClass: "card"
  }, [_c('p', {
    staticClass: "card-eyebrow"
  }, [_c('svg', {
    staticClass: "glyph",
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 12A8 8 0 1 1 12 4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9 1 12 4 9 7"
    }
  })]), _vm._v("\n                            Subscription\n                        ")]), _vm._v(" "), (_vm.isInstitutionAdmin) ? [_c('div', {
    staticClass: "plan-row"
  }, [_c('h2', {
    staticClass: "plan-name"
  }, [_vm._v(_vm._s(_vm.user.subscription_level === 'educational' ? 'Educational' : 'Institutional'))]), _vm._v(" "), _c('span', {
    staticClass: "plan-badge"
  }, [_vm._v("Administrator")])]), _vm._v(" "), _c('p', {
    staticClass: "plan-sub"
  }, [_vm._v("You manage seats and billing for " + _vm._s(_vm.user.institution_name) + "."), (_vm.cancellingCard) ? [_c('br'), _vm._v("Your "), _c('strong', [_vm._v(_vm._s(_vm.cancellingCard.planName))]), _vm._v(" subscription. " + _vm._s(_vm.cancellingCard.endsLine))] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "btn-row"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.switchPlan
    }
  }, [_vm._v("Manage Plan")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-ghost",
    on: {
      "click": _vm.manageActiveUsers
    }
  }, [_vm._v("Manage Active Users")])])] : (_vm.user.active_pay) ? [_vm._m(0), _vm._v(" "), (_vm.user.affiliateInstitution) ? [_c('p', {
    staticClass: "plan-sub"
  }, [_vm._v("Affiliated with "), _c('strong', [_vm._v(_vm._s(_vm.affiliateInstitutionLabel))]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "btn-row"
  }, [_c('button', {
    staticClass: "btn btn-ghost",
    on: {
      "click": _vm.affiliateInstitution
    }
  }, [_vm._v("Update Affiliation")])])] : [(_vm.cancellingCard) ? _c('p', {
    staticClass: "plan-sub"
  }, [_vm._v("Your "), _c('strong', [_vm._v(_vm._s(_vm.cancellingCard.planName))]), _vm._v(" subscription. " + _vm._s(_vm.cancellingCard.endsLine))]) : (_vm.studentCard) ? _c('p', {
    staticClass: "plan-sub"
  }, [_vm._v("Your "), _c('strong', [_vm._v(_vm._s(_vm.studentCard.planName))]), _vm._v(" subscription. " + _vm._s(_vm.studentCard.endsLine))]) : _c('p', {
    staticClass: "plan-sub"
  }, [_vm._v("Your personal Cuelist subscription.")]), _vm._v(" "), _c('div', {
    staticClass: "btn-row"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.switchPlan
    }
  }, [_vm._v("Manage Plan")])])]] : [_vm._m(1), _vm._v(" "), (_vm.affiliationPending) ? [_c('p', {
    staticClass: "plan-sub"
  }, [_vm._v("\n                                    Affiliated with "), _c('strong', [_vm._v(_vm._s(_vm.affiliateInstitutionLabel))]), _vm._v(" —\n                                    "), _c('span', {
    staticClass: "plan-pending"
  }, [_vm._v("awaiting activation")]), _vm._v(".\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "btn-row"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.upgradeSubscription
    }
  }, [_vm._v("Upgrade Account")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-ghost",
    on: {
      "click": _vm.affiliateInstitution
    }
  }, [_vm._v("Update Affiliation")])])] : [_c('p', {
    staticClass: "plan-sub"
  }, [_vm._v("Upgrade to a Collaborator subscription to create and edit projects.")]), _vm._v(" "), _c('div', {
    staticClass: "btn-row"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.upgradeSubscription
    }
  }, [_vm._v("Upgrade Account")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-ghost",
    on: {
      "click": _vm.affiliateInstitution
    }
  }, [_vm._v("Add Affiliation")])])]], _vm._v(" "), _c('pending-affiliations', {
    attrs: {
      "variant": "card",
      "user": _vm.user,
      "pendingReady": _vm.affiliateInvitesReady
    },
    on: {
      "affiliationAccepted": _vm.handleAffiliationAccepted
    }
  })], 2), _vm._v(" "), (_vm.showPassPriceId) ? _c('section', {
    staticClass: "card pass-card"
  }, [_c('div', {
    staticClass: "pass-head"
  }, [_c('div', [_c('p', {
    staticClass: "card-eyebrow"
  }, [_c('svg', {
    staticClass: "glyph",
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-linejoin": "round",
      "stroke-linecap": "round",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "stroke-width": "1.9",
      "d": "M4 5H20A2 2 0 0 1 22 7V9.5A2.5 2.5 0 0 0 22 14.5V17A2 2 0 0 1 20 19H4A2 2 0 0 1 2 17V14.5A2.5 2.5 0 0 0 2 9.5V7A2 2 0 0 1 4 5Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-width": "1.55",
      "stroke-dasharray": "1.4 1.8",
      "d": "M15.6 6.4V17.6"
    }
  })]), _vm._v("\n                                    Show Pass\n                                ")]), _vm._v(" "), _c('h2', {
    staticClass: "pass-title"
  }, [_vm._v("Cover a whole production, one time")])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "btn-row"
  }, [_c('form', {
    attrs: {
      "method": "POST",
      "action": _vm.checkoutUrl
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "mode",
      "value": "payment"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "product"
    },
    domProps: {
      "value": _vm.showPassPriceId
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "user_id"
    },
    domProps: {
      "value": _vm.user.uid
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "email_id"
    },
    domProps: {
      "value": _vm.user.email
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "customer_id"
    },
    domProps: {
      "value": _vm.user.stripe_id
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Buy a Show Pass")])])])]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "card email-prefs"
  }, [_c('p', {
    staticClass: "card-eyebrow"
  }, [_c('svg', {
    staticClass: "glyph",
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 6.5h18v11H3z"
    }
  }), _c('path', {
    attrs: {
      "d": "m3 7 9 6 9-6"
    }
  })]), _vm._v("\n                    Email preferences\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "pref-grid"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "pref-row"
  }, [_vm._m(5), _vm._v(" "), _c('label', {
    staticClass: "pref-switch",
    class: {
      on: _vm.guidanceOn,
      busy: _vm.guidanceSaving
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.guidanceOn),
      expression: "guidanceOn"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.guidanceSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.guidanceOn) ? _vm._i(_vm.guidanceOn, null) > -1 : (_vm.guidanceOn)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.guidanceOn,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.guidanceOn = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.guidanceOn = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.guidanceOn = $$c
        }
      }, _vm.saveGuidance]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "knob"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pref-row"
  }, [_vm._m(6), _vm._v(" "), (!_vm.marketingConsentAnswered) ? _c('p', {
    staticClass: "pref-unset"
  }, [_vm._v("You haven't chosen yet.")]) : _vm._e(), _vm._v(" "), (!_vm.marketingConsentAnswered) ? _c('div', {
    staticClass: "pref-choice"
  }, [_c('button', {
    staticClass: "pref-ans",
    attrs: {
      "type": "button",
      "disabled": _vm.consentSaving
    },
    on: {
      "click": function($event) {
        return _vm.answerMarketingConsent(true)
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "pref-ans ghost",
    attrs: {
      "type": "button",
      "disabled": _vm.consentSaving
    },
    on: {
      "click": function($event) {
        return _vm.answerMarketingConsent(false)
      }
    }
  }, [_vm._v("No thanks")])]) : _c('label', {
    staticClass: "pref-switch",
    class: {
      on: _vm.marketingConsent,
      busy: _vm.consentSaving
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marketingConsent),
      expression: "marketingConsent"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.consentSaving
    },
    domProps: {
      "checked": Array.isArray(_vm.marketingConsent) ? _vm._i(_vm.marketingConsent, null) > -1 : (_vm.marketingConsent)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.marketingConsent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.marketingConsent = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.marketingConsent = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.marketingConsent = $$c
        }
      }, _vm.saveMarketingConsent]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "knob"
  })])])])]), _vm._v(" "), (_vm.notesListIntegrationEnabled) ? _c('section', {
    staticClass: "card nl-band"
  }, [_c('div', {
    staticClass: "nl-band-main"
  }, [_c('div', {
    staticClass: "nl-head"
  }, [_c('p', {
    staticClass: "card-eyebrow"
  }, [_c('svg', {
    staticClass: "glyph",
    attrs: {
      "width": "15",
      "height": "15",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.5 17H7.5A5 5 0 0 1 7.5 7H9.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.5 7H16.5A5 5 0 0 1 16.5 17H14.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M8.5 12H15.5"
    }
  })]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('span', {
    staticClass: "nl-badge",
    class: _vm.notesListAccountStatus.linkStatus === 'linked' ? 'is-linked' : 'is-disconnected'
  }, [_c('span', {
    staticClass: "nl-badge-dot"
  }), _vm._v("\n                            " + _vm._s(_vm.notesListAccountStatus.linkStatus === 'linked' ? 'Connected' : 'Not connected') + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "nl-band-action"
  }, [(_vm.notesListAccountStatus.linkStatus !== 'linked') ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.notesListAccountWorking
    },
    on: {
      "click": _vm.connectNotesListAccount
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.notesListAccountWorking ? 'Connecting…' : 'Connect account') + "\n                            ")]) : _c('button', {
    staticClass: "btn btn-ghost",
    attrs: {
      "disabled": _vm.notesListAccountWorking
    },
    on: {
      "click": _vm.disconnectNotesListAccount
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.notesListAccountWorking ? 'Working…' : 'Disconnect account') + "\n                            ")])])]), _vm._v(" "), (_vm.notesListAccountStatus.linkStatus === 'linked') ? _c('p', {
    staticClass: "nl-copy"
  }, [_vm._v("\n                        Your Cuelist and Notes List accounts are linked.\n                    ")]) : _c('p', {
    staticClass: "nl-copy"
  }, [_vm._v("\n                        Link your Notes List account to sync your work across both sites. Structure sync requires "), _c('strong', [_vm._v("Cuelist + Notes List access")]), _vm._v(".\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "nl-sep",
    attrs: {
      "role": "separator"
    }
  }), _vm._v(" "), (_vm.notesListAccountStatus.linkStatus === 'linked') ? _c('p', {
    staticClass: "nl-hint"
  }, [_vm._v("\n                        Link a project to a production from that project's own Settings menu\n                        (open the project, then Settings > The Notes List).\n                    ")]) : _c('p', {
    staticClass: "nl-hint nl-hint--todo"
  }, [_vm._v("\n                        Connect your Notes List account, then link each production from that\n                        project's own Settings menu.\n                    ")])])]) : _vm._e()]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'sessions'),
      expression: "activeTab === 'sessions'"
    }],
    staticClass: "acct-panel"
  }, [_c('div', {
    staticClass: "sessions"
  }, [_c('div', {
    staticClass: "sessions-head"
  }, [_vm._m(8), _vm._v(" "), (_vm.liveSessions.length) ? _c('span', {
    staticClass: "count-pill"
  }, [_vm._v(_vm._s(_vm.liveSessions.length) + " of 3 active")]) : _vm._e()]), _vm._v(" "), _vm._m(9), _vm._v(" "), (_vm.liveSessions.length > 0) ? _c('div', {
    staticClass: "session-list"
  }, _vm._l((_vm.liveSessions), function(session, index) {
    return _c('div', {
      key: index,
      staticClass: "session-item card",
      class: {
        'is-current': session.isCurrent
      }
    }, [_c('div', {
      staticClass: "dev-ico"
    }, [(session.deviceType === 'Tablet') ? _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "1.8",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('rect', {
      attrs: {
        "x": "5",
        "y": "2.5",
        "width": "14",
        "height": "19",
        "rx": "2"
      }
    }), _c('path', {
      attrs: {
        "d": "M11 18.5h2"
      }
    })]) : (session.deviceType === 'Mobile') ? _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "1.8",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('rect', {
      attrs: {
        "x": "7",
        "y": "2.5",
        "width": "10",
        "height": "19",
        "rx": "2"
      }
    }), _c('path', {
      attrs: {
        "d": "M11 18.5h2"
      }
    })]) : _c('svg', {
      attrs: {
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "1.8",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('rect', {
      attrs: {
        "x": "2.5",
        "y": "4",
        "width": "19",
        "height": "12.5",
        "rx": "1.5"
      }
    }), _c('path', {
      attrs: {
        "d": "M9 20h6M12 16.5V20"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "dev-info"
    }, [_c('p', {
      staticClass: "dev-name"
    }, [_vm._v(_vm._s(session.device)), (session.deviceVendorModel) ? _c('span', [_vm._v(" · " + _vm._s(session.deviceVendorModel))]) : _vm._e(), _vm._v(" "), (session.isCurrent) ? _c('span', {
      staticClass: "cur-pill"
    }, [_vm._v("This device")]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "dev-meta"
    }, [_vm._v(_vm._s(session.os) + " · " + _vm._s(session.ip) + " · " + _vm._s(session.lastActive))])]), _vm._v(" "), (!session.isCurrent) ? [(_vm.loadingSessionId === session.sessionId) ? _c('div', {
      staticClass: "spinner"
    }) : _c('button', {
      staticClass: "btn btn-signout",
      on: {
        "click": function($event) {
          return _vm.confirmLogout(session.sessionId)
        }
      }
    }, [_vm._v("Sign out")])] : _vm._e()], 2)
  }), 0) : _c('div', {
    staticClass: "sessions-loading"
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('span', [_vm._v("Loading your active sessions…")])])]), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "logoutSessionDialog",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.getConfirmContent(),
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.onDialogClose
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "acct-build"
  }, [_c('button', {
    staticClass: "acct-build-btn",
    attrs: {
      "type": "button",
      "title": _vm.buildCopied ? 'Copied' : 'Click to copy build details'
    },
    on: {
      "click": _vm.copyBuildStamp
    }
  }, [_vm._v("\n                " + _vm._s(_vm.buildCopied ? 'Copied to clipboard' : _vm.buildStampText) + "\n            ")])])]), _vm._v(" "), _c('core-footer'), _vm._v(" "), (_vm.passwordModalOpen) ? _c('div', {
    staticClass: "acct-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closePasswordModal.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "acct-modal",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-label": "Change password"
    }
  }, [_c('div', {
    staticClass: "acct-modal-head"
  }, [_c('h2', [_vm._v("Change password")]), _vm._v(" "), _c('button', {
    staticClass: "acct-modal-x",
    attrs: {
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePasswordModal
    }
  }, [_vm._v("✕")])]), _vm._v(" "), _c('p', {
    staticClass: "acct-modal-sub"
  }, [_vm._v("For your Cuelist email login.")]), _vm._v(" "), _c('change-password', {
    on: {
      "close": _vm.closePasswordModal,
      "success": _vm.closePasswordModal
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('upgrade-account', {
    ref: "upgradeAcct"
  }), _vm._v(" "), (!_vm.user.active_pay || (_vm.user.active_pay && _vm.user.affiliateInstitution)) ? _c('affiliate-institution', {
    ref: "affiliateInstitution"
  }) : _vm._e(), _vm._v(" "), (_vm.user.active_pay && (_vm.user.subscription_level == 'educational' || _vm.user.subscription_level == 'institutional' || _vm.user.subscription_level == 'dual_educational' || _vm.user.subscription_level == 'dual_institution')) ? _c('manage-affiliation', {
    ref: "manageAffiliation"
  }) : _vm._e(), _vm._v(" "), (_vm.isPaidCustomer && _vm.user.stripe_id) ? _c('billing-history', {
    ref: "billingHistory"
  }) : _vm._e(), _vm._v(" "), _c('reauthenticate', {
    ref: "reauthenticate",
    on: {
      "close": _vm.onAuthEnd
    }
  }), _vm._v(" "), _c('maintenance-notice', {
    ref: "maintenanceNotice"
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plan-row"
  }, [_c('h2', {
    staticClass: "plan-name"
  }, [_vm._v("Collaborator")]), _vm._v(" "), _c('span', {
    staticClass: "plan-badge"
  }, [_vm._v("Active")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plan-row"
  }, [_c('h2', {
    staticClass: "plan-name"
  }, [_vm._v("Observer")]), _vm._v(" "), _c('span', {
    staticClass: "plan-badge muted"
  }, [_vm._v("Free")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "price-chip"
  }, [_c('span', {
    staticClass: "amt"
  }, [_vm._v("$299")]), _c('span', {
    staticClass: "per"
  }, [_vm._v("one-time")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "pass-copy"
  }, [_vm._v("A Show Pass unlocks "), _c('strong', [_vm._v("one project for your entire team to edit")]), _vm._v(" — no seat limit, and "), _c('strong', [_vm._v("no change to your subscription")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pref-row"
  }, [_c('div', {
    staticClass: "pref-copy"
  }, [_c('p', {
    staticClass: "pref-title"
  }, [_vm._v("Account and billing")]), _vm._v(" "), _c('p', {
    staticClass: "pref-sub"
  }, [_vm._v("Receipts, renewals, invitations and security notices.")])]), _vm._v(" "), _c('span', {
    staticClass: "pref-always"
  }, [_vm._v("Always on")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pref-copy"
  }, [_c('p', {
    staticClass: "pref-title"
  }, [_vm._v("Using Cuelist")]), _vm._v(" "), _c('p', {
    staticClass: "pref-sub"
  }, [_vm._v("How to use the features you already have.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pref-copy"
  }, [_c('p', {
    staticClass: "pref-title"
  }, [_vm._v("Product news and offers")]), _vm._v(" "), _c('p', {
    staticClass: "pref-sub"
  }, [_vm._v("Our newsletter as well as promotions and upgrade offers.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nl-name"
  }, [_vm._v("The "), _c('span', {
    staticClass: "nl-accent"
  }, [_vm._v("Notes")]), _vm._v(" List")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "sessions-title"
  }, [_vm._v("Active sessions")]), _vm._v(" "), _c('p', {
    staticClass: "sessions-sub"
  }, [_vm._v("Devices currently signed in to your Cuelist account.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sessions-note"
  }, [_c('span', {
    staticClass: "note-ico"
  }, [_vm._v("i")]), _vm._v(" "), _c('p', [_vm._v("You can stay signed in on up to "), _c('strong', [_vm._v("3 devices")]), _vm._v(" at once. Signing in on a new device beyond that automatically signs out your oldest session.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab73aee0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/account.vue
// module id = 1281
// module chunks = 21